import { TrainingInsightFragment } from 'generated/resources/graphql'

import { hoursToText } from 'modules/core/lib/duration'

export const useTrainingHours = (insights: TrainingInsightFragment) => {
  const trainingHours = insights.trainingHours
  const totalSessionsHours = trainingHours?.totalSessionsHours || 0
  const averageSessionHoursPerEmployee = trainingHours?.averageSessionHoursPerEmployee || 0

  const hours = hoursToText(averageSessionHoursPerEmployee)
  const totalHours = hoursToText(totalSessionsHours)

  return { totalHours, hours }
}
